// helpers
import { cn } from "src/utils/common.helper"

export const Input = ({
    id,
    type,
    name,
    hasError = false,
    className = "",
    disabled = false,
    ...rest
}) => {
    return (
        <input
            id={id}
            type={type}
            name={name}
            className={cn(
                "block rounded-lg text-base py-2.5 px-3.5 border border-[var(--border-secondary)] focus:border-[var(--border-theme-primary)]",
                { "border-[var(--border-error)]": hasError },
                className,
                { "bg-gray-100": disabled }
            )}
            {...rest}
        />
    )
}
